<template>
  <div class="date-cmp">
    <!-- 计算字段日期字段 -->

    <template v-if="modulesItem?.setting?.fieldType == 24">
      <jw-date-picker :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" v-if="JSON.parse(modulesItem?.setting?.fieldExt)?.dataType == 'YYYY/MM/DD HH:mm' || JSON.parse(modulesItem?.setting?.fieldExt)?.dataType == 'YYYY-MM-DD HH:mm'" v-model="modulesItem.fieldValue" :placeholder="quoteFieldPlaceholder" show-time :value-format="JSON.parse(modulesItem?.setting?.fieldExt)?.dataType" lass="system-form-item-fields ly-form-item-fields-disabled" :format="JSON.parse(modulesItem?.setting?.fieldExt)?.dataType" disabled />

      <jw-date-picker :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" v-else v-model="modulesItem.fieldValue" :placeholder="quoteFieldPlaceholder" class="system-form-item-fields ly-form-item-fields-disabled" :format="JSON.parse(modulesItem?.setting?.fieldExt)?.dataType" disabled />
    </template>

    <jw-date-picker v-else :trigger-props="{ updateAtScroll: true }" v-model="modulesItem.fieldValue" :placeholder="isQuoteField ? quoteFieldPlaceholder : modulesItem?.placeholder || ''" :show-time="isShowTime" :value-format="isShowTime ? 'YYYY-MM-DD HH:mm:00' : 'YYYY-MM-DD'" :class="['system-form-item-fields', isQuoteField ? 'ly-form-item-fields-disabled' : '']" :format="dateExt" :disabled="isQuoteField || modulesItem.businessData == '0' || disabledAll" @change="handleChange" />
  </div>
</template>

<script setup>
import { ref, inject, computed } from 'vue';
const isQuoteField = inject('fhFormFieldsParams')?.isQuoteField;
const quoteFieldPlaceholder = inject('fhFormFieldsParams')?.quoteFieldPlaceholder;

console.log('isQuoteField', isQuoteField);

const emits = defineEmits(['cb']);

const props = defineProps({
  modules: {
    type: Object,
    default: () => {}
  },
  disabledAll: {
    type: Boolean,
    default: false
  }
});

const modulesItem = ref(props?.modules);
const dateExt = computed(() => {
  return isQuoteField.value ? modulesItem.value?.setting?.business?.fieldExt : modulesItem.value?.setting?.fieldExt;
});

// 是否展示时间
const isShowTime = computed(() => {
  if (dateExt.value?.includes('HH:mm') || dateExt.value?.includes('HH:mm:ss') || dateExt.value?.includes('hh:mm')) {
    return true;
  } else {
    return false;
  }
});
const handleChange = () => {
  emits('cb', modulesItem.value);
};
</script>

<style scoped lang="less">
@import './date-cmp.less';
</style>
